import EtiquetasIndex from "@/modules/Etiquetas/pages/Index";
import EtiquetaEditor from "@/modules/Etiquetas/pages/Editor";

export default [
  {
    name: "etiquetasLista",
    path: "/etiquetas",
    component: EtiquetasIndex,
    meta: { title: "Etiquetas", permission: "etiquetas" },
  },
  {
    name: "etiquetasNovo",
    path: "/etiquetas/novo",
    redirect: { name: "etiquetasLista", query: { novo: "1" } },
    meta: { title: "Nova etiqueta", permission: "etiquetas" },
  },
  {
    name: "etiquetasEditar",
    path: "/etiquetas/:uuid/editar",
    component: EtiquetaEditor,
    meta: { title: "Editor de etiquetas", permission: "etiquetas" },
  },
];
